import React, { useEffect, useState } from 'react';
import api, { isSupervisorRole, getCurrentUser } from '../api/expoApi';
import HubSelector from '../components/HubSelector';

export default function CashTransactions() {
    const user = getCurrentUser();
    const isSupervisor = isSupervisorRole(user?.role);
    const [hubId, setHubId] = useState(isSupervisor ? null : (user?.hub_id || user?.hubId));
    const [transactions, setTransactions] = useState([]);
    const [summary, setSummary] = useState([]);
    const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
    const [filter, setFilter] = useState({ from_date: '', to_date: '', transaction_type: '', category: '' });
    const [newTx, setNewTx] = useState({ transaction_type: 'IN', category: '', amount: '', description: '', transaction_date: new Date().toISOString().slice(0, 10), hub_id: '' });
    const [msg, setMsg] = useState('');

    const load = async () => {
        try {
            const [txs, sum] = await Promise.all([
                api.get('/cash', { params: filter }),
                api.get('/cash/summary', { params: { date } })
            ]);
            setTransactions(txs.data?.data || []);
            setSummary(sum.data?.data || []);
        } catch (e) { console.error(e); }
    };

    useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter, date]);

    const recordTx = async () => {
        try {
            const payload = { ...newTx };
            if (!payload.hub_id) delete payload.hub_id;
            await api.post('/cash', payload);
            setMsg('Transaction recorded');
            setNewTx({ ...newTx, amount: '', description: '' });
            load();
        } catch (e) { setMsg(e.response?.data?.message || 'Error'); }
    };

    return (
        <div style={{ padding: 24 }}>
            <h1>Cash Management</h1>

            <div style={{ background: '#f8f9fa', padding: 16, borderRadius: 6, marginBottom: 16 }}>
                <h3>Record Cash Transaction</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 8 }}>
                    <select value={newTx.transaction_type} onChange={(e) => setNewTx({...newTx, transaction_type: e.target.value})}>
                        <option value="IN">Cash IN</option>
                        <option value="OUT">Cash OUT</option>
                    </select>
                    <input placeholder="Category (e.g. COD, RENT, SALARY)" value={newTx.category} onChange={(e) => setNewTx({...newTx, category: e.target.value.toUpperCase()})} />
                    <input type="number" step="0.01" placeholder="Amount (PKR)" value={newTx.amount} onChange={(e) => setNewTx({...newTx, amount: e.target.value})} />
                    <input type="date" value={newTx.transaction_date} onChange={(e) => setNewTx({...newTx, transaction_date: e.target.value})} />
                    <input placeholder="Description" value={newTx.description} onChange={(e) => setNewTx({...newTx, description: e.target.value})} />
                </div>
                <button onClick={recordTx} style={{ marginTop: 8, padding: '8px 24px',
                    background: newTx.transaction_type === 'IN' ? '#198754' : '#dc3545', color: '#fff', border: 'none', borderRadius: 4 }}>
                    Record {newTx.transaction_type}
                </button>
                {msg && <span style={{ marginLeft: 12, color: '#198754' }}>{msg}</span>}
            </div>

            <h3>Daily Cash Position</h3>
            <div style={{ display: 'flex', gap: 12, marginBottom: 12, alignItems: 'center' }}>
                <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
            </div>
            <table style={tableStyle}>
                <thead><tr><th>Hub</th><th>Cash IN</th><th>Cash OUT</th><th>COD</th><th>Net</th><th>Tx Count</th></tr></thead>
                <tbody>
                    {summary.map((s, i) => (
                        <tr key={i}>
                            <td>{s.hub_code}</td>
                            <td style={{ color: '#198754' }}>PKR {Number(s.total_in).toLocaleString()}</td>
                            <td style={{ color: '#dc3545' }}>PKR {Number(s.total_out).toLocaleString()}</td>
                            <td>PKR {Number(s.cod_collected).toLocaleString()}</td>
                            <td style={{ fontWeight: 600 }}>PKR {(Number(s.total_in) - Number(s.total_out)).toLocaleString()}</td>
                            <td>{s.transaction_count}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <h3 style={{ marginTop: 32 }}>Transactions</h3>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
                <input type="date" value={filter.from_date} onChange={(e) => setFilter({...filter, from_date: e.target.value})} placeholder="From" />
                <input type="date" value={filter.to_date} onChange={(e) => setFilter({...filter, to_date: e.target.value})} placeholder="To" />
                <select value={filter.transaction_type} onChange={(e) => setFilter({...filter, transaction_type: e.target.value})}>
                    <option value="">All types</option><option value="IN">IN</option><option value="OUT">OUT</option>
                </select>
                <input placeholder="Category" value={filter.category} onChange={(e) => setFilter({...filter, category: e.target.value})} />
            </div>
            <table style={tableStyle}>
                <thead><tr><th>Date</th><th>Hub</th><th>Type</th><th>Category</th><th>Amount</th><th>Description</th></tr></thead>
                <tbody>
                    {transactions.length === 0 && <tr><td colSpan="6" style={{ textAlign: 'center', padding: 16 }}>No transactions</td></tr>}
                    {transactions.map((t) => (
                        <tr key={t.cash_tx_id}>
                            <td>{t.transaction_date}</td>
                            <td>{t.hub_code}</td>
                            <td style={{ color: t.transaction_type === 'IN' ? '#198754' : '#dc3545', fontWeight: 600 }}>{t.transaction_type}</td>
                            <td>{t.category}</td>
                            <td>PKR {Number(t.amount).toLocaleString()}</td>
                            <td>{t.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

const tableStyle = { width: '100%', borderCollapse: 'collapse', background: '#fff' };
